import { useUser } from 'src/contexts/UserContext';
import { isChildUser, isParentUser } from 'src/utils/userRole';

export const useUserRole = () => {
  const { me } = useUser();
  return {
    isParent: isParentUser(me),
    isChild: isChildUser(me),
  };
};
